import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { CelularesTable } from "./celulares-table";
import { CelularForm } from "./celular-form";
import { CelularesProvider } from "./celulares-context";

export function CelularesRoutes() {
  return (
    <RoleGuard roles={["empresa:celulares"]}>
      <CelularesProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<CelularesTable />} />

            <Route path="add" element={<CelularForm />} />

            <Route path=":celular_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<CelularForm />} />
            </Route>

            <Route path="*" element="Celulares: Page Not Found" />
          </Route>
        </Routes>
      </CelularesProvider>
    </RoleGuard>
  );
}
